import React, { ComponentType } from 'react'
import {
  InterstitialPageMetadataFragment,
  InterstitialPathFlowPageMetadataType
} from '#src/generated/graphql'

export interface InterstitialProps {
  categorySlug?: string
  onPageSubmitted: () => void
  onPageBack: () => void
  pathFlowId: string
  submitButtonText: string
  title?: string
  body?: string
  metadata: InterstitialPageMetadataFragment
  isBackButtonHidden: boolean
  isSubmitting: boolean
}

export type InterstitialMap = {
  [name in InterstitialPathFlowPageMetadataType]?: ComponentType<InterstitialProps>
}

interface InterstitialBuilderProps extends InterstitialProps {
  interstitialMap: InterstitialMap
  pageSlug: string
}

const InterstitialBuilder: React.SFC<InterstitialBuilderProps> = ({
  interstitialMap,
  metadata,
  pageSlug,
  ...rest
}) => {
  const interstitialType = metadata.interstitialType

  let ActiveInterstitial: React.ComponentType<InterstitialProps> | undefined
  if (interstitialMap[interstitialType]) {
    ActiveInterstitial = interstitialMap[interstitialType]
  }

  if (!ActiveInterstitial) {
    throw new Error(`Undefined Interstitial referenced, [${interstitialType}]`)
  }

  return <ActiveInterstitial key={pageSlug} metadata={metadata} {...rest} />
}

export default InterstitialBuilder
